import React from 'react';
import _ from 'lodash';
import {Header, Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const ThirdPartyShipStationHeader = ({model}) => (
    <div>
        <Header as='h2'>
            <Icon name='settings' />
            <Header.Content>
                Third Party ShipStation
                <Header.Subheader>API Key: {model.key_1}</Header.Subheader>
                <Header.Subheader>API Secret: {model.key_2}</Header.Subheader>
                <Header.Subheader>Last Synchronize: {_.isObject(model.synchronize) ? model.synchronize.updated_at : null}</Header.Subheader>
            </Header.Content>
        </Header>
    </div>
)

ThirdPartyShipStationHeader.propTypes = {
    model: PropTypes.object.isRequired
};


export default ThirdPartyShipStationHeader